export default __webpack_public_path__ + "static/media/vals.372adf2d.png";